var map = {
	"./Home.vue": [
		"bb51",
		"chunk-ee4faf38"
	],
	"./easy/Baymax.vue": [
		"7bf8",
		"chunk-c9263cfe"
	],
	"./easy/Bear.vue": [
		"10ed",
		"chunk-934d1fac"
	],
	"./easy/Brokenline.vue": [
		"1c69",
		"chunk-4d174ac7"
	],
	"./easy/Circle.vue": [
		"7672",
		"chunk-70997a0a"
	],
	"./easy/Counter.vue": [
		"f071",
		"chunk-79f451db"
	],
	"./easy/Dog.vue": [
		"2f4a",
		"chunk-8afe119e"
	],
	"./easy/Dragon-ball-radar.vue": [
		"774d",
		"chunk-75e67da8"
	],
	"./easy/Dragon-egg.vue": [
		"4c07",
		"chunk-24ba8b3b"
	],
	"./easy/Drop.vue": [
		"1896",
		"chunk-cea5550a"
	],
	"./easy/Envelope.vue": [
		"52f6",
		"chunk-337e0842"
	],
	"./easy/Eyepassword.vue": [
		"92db",
		"chunk-776aa5f8"
	],
	"./easy/Fadingtext.vue": [
		"161e",
		"chunk-4b242196"
	],
	"./easy/Fan.vue": [
		"3544",
		"chunk-4ee82c90"
	],
	"./easy/Fast-food.vue": [
		"8bf9",
		"chunk-9e91d996"
	],
	"./easy/Flybox.vue": [
		"75eb",
		"chunk-82529392"
	],
	"./easy/Foodcard.vue": [
		"7afb",
		"chunk-137b18dc"
	],
	"./easy/Halloween.vue": [
		"24d6",
		"chunk-88c7dcfc"
	],
	"./easy/Heart.vue": [
		"88b2",
		"chunk-9c9dc760"
	],
	"./easy/Lion.vue": [
		"a6eb",
		"chunk-0d7ac1b6"
	],
	"./easy/Man.vue": [
		"51ea",
		"chunk-a4379334"
	],
	"./easy/Moire.vue": [
		"8e4c",
		"chunk-3c94023e"
	],
	"./easy/Notfount.vue": [
		"339c",
		"chunk-fec61064"
	],
	"./easy/Researcher.vue": [
		"2c13",
		"chunk-50b7e7f5"
	],
	"./easy/Rotateinput.vue": [
		"f8bd",
		"chunk-bea428aa"
	],
	"./easy/Spotlight.vue": [
		"f9a3",
		"chunk-6008615e"
	],
	"./easy/Sunload.vue": [
		"a1a2",
		"chunk-5f9033aa"
	],
	"./easy/Super-dragon-y.vue": [
		"d275",
		"chunk-f872d160"
	],
	"./easy/Tick.vue": [
		"8a2e",
		"chunk-28ddfdaf"
	],
	"./easy/Turncard.vue": [
		"0fd8",
		"chunk-00c77392"
	],
	"./easy/Wave.vue": [
		"c009",
		"chunk-5d167656"
	],
	"./normal/Fish.vue": [
		"8bcb",
		"chunk-ff38b806"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;